import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementRiverCreateMutation, useMeasurementRiverFindAllQuery, useMeasurementRiverUpdateMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import Flatpickr from "react-flatpickr";

import measurementSvg from "../../../assets/images/svg/measurement.svg"

const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementRiverFindAllQuery(`?river_id=${id}`);
  const [measurementRiverCreate, measurementRiverCreateResult] = useMeasurementRiverCreateMutation();
  const [measurementRiverUpdate, measurementRiverUpdateResult] = useMeasurementRiverUpdateMutation();
  const [measurementRiver, setMeasurementRiver] = useState<any>();

  const [contains_water, setContains_waterBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleanBoolean] = useState<boolean>(false);
  const [channel_changes, setChannel_changes] = useState<boolean>(false);

  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);
  const [measurementList, setMeasurementList] = useState<any>();
  const [meaCount, setMeaCount] = useState<any>();

  const {
    data: commonRiver,
    error: commonRiverError,
    isFetching: isCommonRiverFetching,
  } = useCommonDataFindAllQuery(`?group_name=cmd_river_mode`);

  useEffect(() => {

    if (measurementRiver === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    setMeasurementList(data?.data);
    const tempContains_water = measurementRiver !== null ? measurementRiver?.contains_water : false;
    const tempIs_clean = measurementRiver !== null ? measurementRiver?.is_clean : false;
    const tempChannel_changes = measurementRiver !== null ? measurementRiver?.channel_changes : false;

    setContains_waterBoolean(tempContains_water)
    setIs_cleanBoolean(tempIs_clean)
    setChannel_changes(tempChannel_changes)

  }, [measurementRiver, commonRiver, id, data?.data])


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: measurementRiver?.id,
      river_id: measurementRiver?.river_id,
      river_code: measurementRiver?.river_code,
      averagefall_channel: measurementRiver?.averagefall_channel,
      measure_date: measurementRiver?.measure_date,
      average_run: measurementRiver?.average_run,
      length: measurementRiver?.length,
      wide: measurementRiver?.wide,
      flow_rate: measurementRiver?.flow_rate,
      average_depth: measurementRiver?.average_depth,
      basin_size: measurementRiver?.basin_size,
      cmd_river_mode: measurementRiver?.cmd_river_mode,
      river_mode_name: measurementRiver?.river_mode_name,
      guard_position: measurementRiver?.guard_position,
      usage_information: measurementRiver?.usage_information,
      sanitary_requirements: measurementRiver?.sanitary_requirements,
      water_physical_quality: measurementRiver?.water_physical_quality,
      report_autor: measurementRiver?.report_autor,
      report_name: measurementRiver?.report_name,
      report_code: measurementRiver?.report_code,

      channel_changes: measurementRiver?.channel_changes,
      contains_water: measurementRiver?.contains_water,
      is_clean: measurementRiver?.is_clean,
    },
    validationSchema: Yup.object({
      river_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      averagefall_channel: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      measure_date: Yup.date().typeError("Он сар өдөр оруулна уу!").required("Утга оруулна уу"),
      average_run: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      length: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      wide: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      flow_rate: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      average_depth: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      basin_size: Yup.number().typeError("Тоон төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      cmd_river_mode: Yup.number().typeError("Утга сонгоно уу!").required("Утга оруулна уу"),
      guard_position: Yup.string().typeError("Текст төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      water_physical_quality: Yup.string().typeError("Текст төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу!").required("Утга оруулна уу"),
      report_code: Yup.string().typeError("Текст төрлийн утга оруулна уу!").required("Утга оруулна уу"),
    }),
    onSubmit: (values: any) => {
      if (measurementRiver !== null) {
        const updateList = {
          id: measurementRiver?.id,
          river_id: measurementRiver?.river_id,
          river_code: values.river_code,
          averagefall_channel: values.averagefall_channel,
          measure_date: values.measure_date,
          average_run: values.average_run,
          length: values.length,
          wide: values.wide,
          flow_rate: values.flow_rate,
          average_depth: values.average_depth,
          basin_size: values.basin_size,
          cmd_river_mode: values.cmd_river_mode,
          guard_position: values.guard_position,
          usage_information: values.usage_information,
          sanitary_requirements: values.sanitary_requirements,
          water_physical_quality: values.water_physical_quality,
          report_autor: values.report_autor,
          report_name: values.report_name,
          report_code: values.report_code,
          contains_water: contains_water === undefined ? false : contains_water,
          is_clean: is_clean === undefined ? false : is_clean,
          channel_changes: channel_changes === undefined ? false : channel_changes,
        }

        measurementRiverUpdate(updateList);
      } else {
        const newList = {
          river_id: id,
          river_code: values["river_code"],
          averagefall_channel: values["averagefall_channel"],
          measure_date: values["measure_date"],
          average_run: values["average_run"],
          length: values["length"],
          wide: values["wide"],
          flow_rate: values["flow_rate"],
          average_depth: values["average_depth"],
          basin_size: values["basin_size"],
          cmd_river_mode: values["cmd_river_mode"],
          guard_position: values["guard_position"],
          usage_information: values["usage_information"],
          sanitary_requirements: values["sanitary_requirements"],
          water_physical_quality: values["water_physical_quality"],
          report_autor: values["report_autor"],
          report_name: values["report_name"],
          report_code: values["report_code"],
          contains_water: contains_water === undefined ? false : contains_water,
          is_clean: is_clean === undefined ? false : is_clean,
          channel_changes: Boolean(channel_changes),
        };

        console.log(newList);

        measurementRiverCreate(newList)
      }
      validation.resetForm();
    },
  });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>
      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementRiver(null);
                setIs_cleanBoolean(false);
                setContains_waterBoolean(false)
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>

          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementRiver(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg="4">
                    <div className="mb-3">
                      <Label className="fw-semibold"> Код </Label>
                      <Input
                        name="river_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.river_code || ""}
                        invalid={
                          validation.touched.river_code &&
                            validation.errors.river_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.river_code &&
                        validation.errors.river_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.river_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын дундаж урсац (м³/с) </Label>
                      <Input
                        name="average_run"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.average_run || ""}
                        invalid={
                          validation.touched.average_run &&
                            validation.errors.average_run
                            ? true
                            : false
                        }
                      />
                      {validation.touched.average_run &&
                        validation.errors.average_run ? (
                        <FormFeedback type="invalid">
                          {validation.errors.average_run}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Дундаж гүн  (м) </Label>
                      <Input
                        name="average_depth"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.average_depth || ""}
                        invalid={
                          validation.touched.average_depth &&
                            validation.errors.average_depth
                            ? true
                            : false
                        }
                      />
                      {validation.touched.average_depth &&
                        validation.errors.average_depth ? (
                        <FormFeedback type="invalid">
                          {validation.errors.average_depth}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын голдиролд өөрчлөлт оруулсан эсэх  </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setChannel_changes(!channel_changes);
                        }}
                        checked={channel_changes}
                      />
                      {validation.touched.channel_changes &&
                        validation.errors.channel_changes ? (
                        <FormFeedback type="invalid">
                          {validation.errors.channel_changes}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын (хэрэглээний) талаарх мэдээлэл  </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлан зохиогчийн нэр  </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Устай эсэх </Label>
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setContains_waterBoolean(!contains_water);
                        }}
                        checked={contains_water}
                      />

                    </div>

                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Урт (м) </Label>
                      <Input
                        name="length"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.length || ""}
                        invalid={
                          validation.touched.length &&
                            validation.errors.length
                            ? true
                            : false
                        }
                      />
                      {validation.touched.length &&
                        validation.errors.length ? (
                        <FormFeedback type="invalid">
                          {validation.errors.length}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Урсгалын хурд (м/с)</Label>
                      <Input
                        name="flow_rate"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.flow_rate || ""}
                        invalid={
                          validation.touched.flow_rate &&
                            validation.errors.flow_rate
                            ? true
                            : false
                        }
                      />
                      {validation.touched.flow_rate &&
                        validation.errors.flow_rate ? (
                        <FormFeedback type="invalid">
                          {validation.errors.flow_rate}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын горим </Label>
                      <Input
                        name="cmd_river_mode"
                        type="select"
                        className="form-select"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cmd_river_mode || ""}
                        invalid={
                          validation.touched.cmd_river_mode &&
                            validation.errors.cmd_river_mode
                            ? true
                            : false
                        }
                      >
                        <option disabled value="">Сонгох</option>

                        {commonRiver?.data?.map((item, index) => (
                          <option value={item?.id}>{item?.name}</option>
                        ))}

                      </Input>
                      {validation.touched.cmd_river_mode &&
                        validation.errors.cmd_river_mode ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cmd_river_mode}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр,эрүүл ахуйн шаардлага хангалт, хамгаалалтын талаарх мэдээлэл   </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн нэр </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Эрүүл ахуйн шаардлага хангасан эсэх </Label>
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleanBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />

                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Голын голдрилын дундаж уналт(хэвгий)  </Label>
                      <Input
                        name="averagefall_channel"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.averagefall_channel || ""}
                        invalid={
                          validation.touched.averagefall_channel &&
                            validation.errors.averagefall_channel
                            ? true
                            : false
                        }
                      />
                      {validation.touched.averagefall_channel &&
                        validation.errors.averagefall_channel ? (
                        <FormFeedback type="invalid">
                          {validation.errors.averagefall_channel}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Өргөн(м) </Label>
                      <Input
                        name="wide"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.wide || ""}
                        invalid={
                          validation.touched.wide &&
                            validation.errors.wide
                            ? true
                            : false
                        }
                      />
                      {validation.touched.wide &&
                        validation.errors.wide ? (
                        <FormFeedback type="invalid">
                          {validation.errors.wide}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">Хэмжээ</Label>
                      <Input
                        name="basin_size"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.basin_size || ""}
                        invalid={
                          validation.touched.basin_size &&
                            validation.errors.basin_size
                            ? true
                            : false
                        }
                      />
                      {validation.touched.basin_size &&
                        validation.errors.basin_size ? (
                        <FormFeedback type="invalid">
                          {validation.errors.basin_size}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Харуулын нэр, байршил	 </Label>
                      <Input
                        name="guard_position"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.guard_position || ""}
                        invalid={
                          validation.touched.guard_position &&
                            validation.errors.guard_position
                            ? true
                            : false
                        }
                      />
                      {validation.touched.guard_position &&
                        validation.errors.guard_position ? (
                        <FormFeedback type="invalid">
                          {validation.errors.guard_position}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Усны физик чанар </Label>
                      <Input
                        name="water_physical_quality"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.water_physical_quality || ""}
                        invalid={
                          validation.touched.water_physical_quality &&
                            validation.errors.water_physical_quality
                            ? true
                            : false
                        }
                      />
                      {validation.touched.water_physical_quality &&
                        validation.errors.water_physical_quality ? (
                        <FormFeedback type="invalid">
                          {validation.errors.water_physical_quality}
                        </FormFeedback>
                      ) : null}
                    </div>


                    <div className="mb-3">
                      <Label className="fw-semibold"> Тайлангийн фондын бүртгэлийн дугаар 	 </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>
      </Row>

    </>
  )
}

export default Measurement;